import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import(`./assets/theme/${process.env.VUE_APP_RESELLER_ID}/css/style.scss`)
import(`./assets/theme/${process.env.VUE_APP_RESELLER_ID}/images/favicon.ico`)

import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/'

import appLocalStorage from './util/appLocalStorage'

import BootstrapVue from 'bootstrap-vue'

// import 'bootstrap/dist/css/bootstrap.css'
// import 'bootstrap-vue/dist/bootstrap-vue.css'

// import(`./assets/theme/${process.env.VUE_APP_RESELLER_ID}/css/style.scss`)
// import(`./assets/theme/${process.env.VUE_APP_RESELLER_ID}/images/favicon.ico`)

import Loading from 'vue-loading-overlay'

import 'vue-loading-overlay/dist/vue-loading.css'

import AirbnbStyleDatepicker from 'vue-airbnb-style-datepicker'
import 'vue-airbnb-style-datepicker/dist/vue-airbnb-style-datepicker.min.css'

import TaurusValid from './plugins/Validation/plugin'
import './plugins/Validation/Styles/styles.css';
import loadPolyfills from './polyfills'

import {TextManager, getTextItems} from './util/TextManager'

Vue.use(TaurusValid, {
  feedback: {
    valid: false,
    invalid: true
  },
  control: {
    valid: false,
    invalid: false
  }
})

Vue.use(BootstrapVue)

Vue.use(Loading)

const datepickerOptions = {}

Vue.use(AirbnbStyleDatepicker, datepickerOptions)

router.beforeEach((to, from, next) => {
  const loggedIn = store.state.authentication.user != null
  const userExists = store.state.claimform.userExists

  // check if form
  if (to.matched.some(record => record.meta.checkForUser)) {
    if (!loggedIn && userExists) {
      // if user exists make them log on...

      next({
        name: 'login',
        query: { returnurl: to.fullPath }
      })
    // } else {
    //   next();
    // }
    } /* else {
    // return next(); */
  }

  if (to.matched.some(record => record.meta.requireAuth)) {
    if (!loggedIn) {
      next({
        name: 'login',
        query: { returnurl: to.fullPath }
      })
    } else {
      next()
    }
  }/* else { */
  return next()
  // }
})

store.subscribe((muation, state) => {
  appLocalStorage.setStore(JSON.stringify(state))
})

// -- Session timeout 20 mins of inactivity -- //
let clearSession = () => {
  appLocalStorage.clearStore()
  store.dispatch('authentication/logout')
  store.dispatch('myclaims/reset')
  store.dispatch('claimform/reset')
  store.dispatch('repairoptions/reset')

  router.push({ path: '/' })
  window.location.reload(true)
}

let timer

let resetSessionTimeout = () => {
  if (typeof (timer) !== 'undefined') {
    timer = clearTimeout(timer)
  }
  timer = setTimeout(clearSession, 20 * 60000)
  appLocalStorage.setTimestamp()
}

window.addEventListener('touchstart', resetSessionTimeout, false)
window.addEventListener('click', resetSessionTimeout, false)
window.addEventListener('keypress', resetSessionTimeout, false)
// -- Session timeout 20 mins of inactivity -- //

window.onbeforeunload = function (e) {
  appLocalStorage.clear()
}

Vue.config.productionTip = false

const options = {
	resellerId: parseInt(process.env.VUE_APP_RESELLER_ID),
  textItems: getTextItems()
}

const textManager = new TextManager(options);
Vue.prototype.$textManager = textManager;
Vue.prototype.$allValidators

loadPolyfills().then(
  new Vue({
    router,
    store,
    render: h => h(App)
  }).$mount('#app')
)
